import React from "react";
import { Link } from "react-router-dom";
import backIcon from "../../assets/images/public/back-icon.png";
import Header from "./header";
import Footer from "./footer";
import userService from "../../services/user.service";
import ReactPlayer from "react-player";

//  commom-email and phone number
import { emailAddress, phoneNumber } from "../../common";

class ContactUs extends React.Component {
  state = {
    faqsDetailsResponses: [],
    productRelatedVideosDetailsResponses: [],
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getFAQ();
    this.getRelatedVideos();
  }

  getFAQ() {
    userService.getFaqQuestions().then((res) => {
      this.setState({
        faqsDetailsResponses: res.data.data.faqsDetailsResponses,
      });
    });
  }

  getRelatedVideos() {
    userService.getRelatedVideo().then((res) => {
      this.setState({
        productRelatedVideosDetailsResponses:
          res.data.data.productRelatedVideosDetailsResponses,
      });
    });
  }

  render() {
    const { faqsDetailsResponses, productRelatedVideosDetailsResponses } =
      this.state;
    return (
      <section className="guidlelines-section">
        <div className="guidlelines-container">
          <div className="screen-title-container">
            <div className="screen-title-content">
              <Link className="back-button-container" to="/">
                <img src={backIcon} alt="back" />
              </Link>
              <div>
                Guide<span>lines</span>
              </div>
            </div>
          </div>
          <div className="faq-section">
            <div className="screen-sub-title">Frequently asked questions</div>
            <div className="faq-section-tile-container">
              {faqsDetailsResponses?.map((item, index) => (
                <div className="faq-section-tile" key={index}>
                  <div className="faq-tile-title">{item.question}</div>
                  <div className="faq-tile-content">{item.answer}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="">
            <div className="screen-sub-title">Product related videos</div>
          </div>
          <div className="grid-container">
            {productRelatedVideosDetailsResponses?.map((item, index) => (
              <div className="faq-section-tile grid-columns2">
                <div>
                  <ReactPlayer
                    className="video-player"
                    url={item.uploadedFiles.filePath}
                    playing={false}
                    controls
                  />
                </div>
                <div className="faq-tile-title">{item.title}</div>
                <div className="faq-tile-content">{item.details}</div>
              </div>
            ))}
          </div>
          <div className="faq-support-container">
            If you have any questions, please reply to this email or contact us
            at: <br />
            <span>{emailAddress} </span> or <span>{phoneNumber}</span>
          </div>
        </div>
      </section>
    );
  }
}

export default ContactUs;
